module.exports = __webpack_public_path__ + "static/media/hugo.bd3b1aca.svg";